module.exports = __webpack_public_path__ + "img/dwg.5b334e9a.png";